import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import {loadViewById} from 'state/view/viewActions';
import {
  selectCardId,
  selectBackgroundId,
  selectFitToFrame,
  selectStyles,
} from 'state/view/viewSelectors';

class EmbedViewHandler extends React.Component {
  componentDidMount() {
    this.props.loadViewById(this.props.viewId);
  }

  UNSAFE_componentWillReceiveProps({viewId}) {
    if (this.props.viewId !== viewId) {
      this.props.loadViewById(viewId);
    }
  }

  render() {
    const {cardId, backgroundId, children, fitToFrame, viewStyle} = this.props;

    if (!cardId) return null;

    return children({cardId, backgroundId, fitToFrame, viewStyle});
  }
}

EmbedViewHandler.propTypes = {
  viewId: PropTypes.string.isRequired,
  children: PropTypes.func.isRequired,
};

export default connect(
  (state, {viewId}) => ({
    cardId: selectCardId(state, viewId),
    backgroundId: selectBackgroundId(state, viewId),
    fitToFrame: selectFitToFrame(state, viewId),
    viewStyle: selectStyles(state, viewId),
  }),
  {loadViewById}
)(EmbedViewHandler);
